var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1094_2557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.17358 24H17.745C20.2539 24 21.7239 22.5276 21.7239 19.8489V7.6028L18.6718 10.654V19.4764C18.6718 20.4816 18.1642 20.9487 17.4145 20.9487H4.50416C3.55374 20.9487 3.04606 20.4816 3.04606 19.4764V6.76904C3.04606 5.75789 3.55374 5.29075 4.50416 5.29075H13.418L16.4641 2.23955H4.17358C1.48171 2.23955 0 3.71194 0 6.39059V19.8489C0 22.5335 1.48171 24 4.17358 24ZM8.91977 15.686L11.4995 14.6454L21.8419 4.29142L19.7108 2.17451L9.38022 12.5225L8.31174 15.0651C8.15826 15.4495 8.56558 15.822 8.91977 15.686ZM22.7923 3.34532L23.5716 2.54704C24.1206 1.98529 24.1501 1.19293 23.6128 0.672573L23.2351 0.294131C22.7687 -0.161182 21.9541 -0.0724852 21.4228 0.453785L20.6612 1.21658L22.7923 3.34532Z",
    fill: "current",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1094_2557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/TestIcon.1d39c8093af2fde44a4f153424172009.svg";
export { ForwardRef as ReactComponent };